// TopHeader.js
import React from 'react';
import { Box, Typography } from '@mui/material';
import { property_pincode_new } from './ImageConstants';

const TopHeader = () => {
  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 1200,
        color: "rgb(232, 243, 149)",
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        borderRadius: '10px',
        backgroundColor: 'rgba(232,224,208,0.95)'
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        px={1}
        py={0.5}
        sx={{ borderBottom: '1px solid rgba(0,0,0,0.08)', height: '44px' }}
      >
        <Typography
          variant="subtitle1"
          sx={{
            color: "rgb(0, 0, 0)",
            fontWeight: 'bold',
            fontFamily: "'Cinzel', serif",
            letterSpacing: 0.5,
            ml: 1,
          }}
        >
          PROPERTY PINCODER
        </Typography>

        {/* Logo Image */}
        <Box
          sx={{
            width: 90,
            height: 46,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img
            src={property_pincode_new}
            alt="Property pincoder Logo"
            style={{
              width: '100%',
              height: 'auto',
              maxHeight: '100%',
              objectFit: 'contain',
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default TopHeader;